import { Box } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useLocalStorage } from "@src/appV2/lib/utils/useLocalstorage";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { useGetCbhWrappedInsights } from "./api/useGetCbhWrappedInsights";
import { CbhWrappedBanner } from "./Banner";
import { CBH_WRAPPED_PATH } from "./paths";
import { useIsCbhWrappedEnabled } from "./useIsCbhWrappedEnabled";

export function CbhWrappedEntrypoint() {
  const isCbhWrappedEnabled = useIsCbhWrappedEnabled();

  const worker = useDefinedWorker();

  const [isBannerDismissed, setIsBannerDismissed] = useLocalStorage<boolean>(
    "cbh-wrapped-banner-dismissed",
    false
  );

  const { data: wrappedInsights, isSuccess: isWrappedInsightsSuccess } = useGetCbhWrappedInsights({
    enabled: isCbhWrappedEnabled,
  });

  const history = useHistory();

  if (!isCbhWrappedEnabled) {
    return null;
  }

  if (!isWrappedInsightsSuccess || wrappedInsights?.data.length === 0) {
    return null;
  }

  return (
    !isBannerDismissed && (
      <Box sx={{ marginX: 6, marginY: 4 }}>
        <CbhWrappedBanner
          source="home-screen"
          onClick={() => {
            history.push(`${RootPaths.APP_V2_HOME}/${CBH_WRAPPED_PATH}`);

            logEvent(APP_V2_USER_EVENTS.CBH_WRAPPED_PAGE_VIEWED, {
              source: "banner-home-screen",
              workerId: worker.userId,
            });
          }}
          onClose={() => {
            setIsBannerDismissed(true);
          }}
        />
      </Box>
    )
  );
}
